<div [formGroup]="formRegister" class="linked-properties">
  <ng-container *ngIf="locationsAdded.length > 0">
    <div class="linked-properties__header">
      <h4 class="linked-properties__title">Propriedades vinculadas</h4>
      <span class="linked-properties__badge" aria-live="polite">{{ locationsAdded.length }}</span>
    </div>

    <div class="linked-properties__list">
      <article
        *ngFor="let location of paginatedLocations; trackBy: trackByLocation"
        class="property-card">
        <header class="property-card__header">
          <div class="property-card__summary">
            <p class="property-card__summary-item">
              <span class="property-card__label">Proprietário</span>
              <span class="property-card__value">{{ location.landOwnerFullName }}</span>
            </p>
            <p class="property-card__summary-item">
              <span class="property-card__label">CNPJ/CPF</span>
              <span class="property-card__value">{{ formatDocument(location.landOwnerCpfCnpj) }}</span>
            </p>
            <p class="property-card__summary-item">
              <span class="property-card__label">Município</span>
              <span class="property-card__value">{{ location.municipality }}</span>
            </p>
          </div>
          <div class="property-card__actions">
            <button
              type="button"
              class="property-card__remove-btn"
              aria-label="Remover propriedade"
              (click)="deleteLocation(location)">
              <b3-icon name="delete" size="sm"></b3-icon>
            </button>
          </div>
        </header>

        <div class="property-card__body">
          <dl class="property-card__details">
            <div class="property-card__detail">
              <dt>Coordenadas</dt>
              <dd>{{ getCoordinatesLabel(location) }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>País</dt>
              <dd>{{ location.country }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>UF</dt>
              <dd>{{ location.state }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>Hectares totais</dt>
              <dd>{{ location.totalHectares }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>Hectares de geração de carbono</dt>
              <dd>{{ location.carbonGenerationHectares }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>Hectares disponíveis</dt>
              <dd>{{ location.availableHectares }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>Bioma</dt>
              <dd>{{ formatBiome(location.biome) }}</dd>
            </div>
            <div class="property-card__detail">
              <dt>CAR. Registro de inscrição</dt>
              <dd>{{ location.registrationRecord }}</dd>
            </div>
            <div class="property-card__detail property-card__detail--full">
              <dt>CAR. Link do demonstrativo online</dt>
              <dd>{{ location.registrationRecordLink }}</dd>
            </div>
          </dl>
        </div>
      </article>
    </div>

    <footer class="linked-properties__footer">
      <p class="linked-properties__count">
        Mostrando {{ locationsAdded.length }}
        {{ locationsAdded.length === 1 ? 'propriedade vinculada' : 'propriedades vinculadas' }}
      </p>
      <nav class="linked-properties__pagination" aria-label="Paginação de propriedades vinculadas">
        <button
          type="button"
          class="linked-properties__page-btn"
          aria-label="Página anterior"
          [disabled]="currentPage <= 1"
          (click)="goToPage(currentPage - 1)">
          <b3-icon name="chevron_left" size="sm"></b3-icon>
        </button>
        <span class="linked-properties__page-current" aria-current="page">{{ currentPage }}</span>
        <button
          type="button"
          class="linked-properties__page-btn"
          aria-label="Próxima página"
          [disabled]="currentPage >= totalPages"
          (click)="goToPage(currentPage + 1)">
          <b3-icon name="chevron_right" size="sm"></b3-icon>
        </button>
      </nav>
    </footer>
  </ng-container>
</div>